import { CCard, CCardBody, CCol, CCardHeader, CRow } from '@coreui/react'
import {
    CChartBar,
    CChartDoughnut,
    CChartLine,
    CChartPie,
    CChartPolarArea,
    CChartRadar,
} from '@coreui/react-chartjs'
import { DocsCallout } from 'src/components';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Checkbox, Collapse, Modal } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { apiUrls } from '../../apiUrls.js';
import Program from "../../components/Program.js";
import { useNavigate } from 'react-router-dom';
import { UnlockOutlined, LockOutlined, EditOutlined, SearchOutlined, DeleteOutlined, DollarOutlined } from '@ant-design/icons';
import AmountFormat from "../../components/AmountFormat.js";
import InputNumberFormat from "../../components/InputNumberFormat.js";
import DatePicker, { utils } from '@hassanmojab/react-modern-calendar-datepicker';
import { UploadOutlined } from '@ant-design/icons';
import jquery from 'jquery';
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";

const { Option } = Select;

const baseURL = apiUrls.baseURL;

const BillList = () => {

    const initialBillModel = {
        amount: '',
        userId: '',
        billType: '',
        description: '',
        payDateDeadLine: ''
    };

    const [data, setData] = useState([]);
    const [billModel, setBillModel] = useState(initialBillModel);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [payLoading, setPayLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [id, setId] = useState(0);
    const [count, setCount] = useState(0);
    const [isShowDeleteConfirmModalVisible, setIsShowDeleteConfirmModalVisible] = useState(false);
    const [isShowPayConfirmModalVisible, setIsShowPayConfirmModalVisible] = useState(false);
    const [filter, setFilter] = useState({ skip: 0, limit: 20, data: {} });
    const [dropDownBillType, setDropDownBillTypes] = useState([]);
    const [dropDownUser, setDropDownUsers] = useState([]);
    const [payDeadLineDate, setPayDeadLineDate] = useState(null);
    const [fromCreateDate, setFromCreateDate] = useState(null);
    const [toCreateDate, setToCreateDate] = useState(null);
    const [isShowCreateBillModalVisible, setIsShowCreateBillModalVisible] = useState(false);
    const [billPhoto, setBillPhoto] = useState('');
    const permissions = useSelector((state) => state.permissions.permissions);
    const navigate = useNavigate();
    const [reload, setReload] = useState(0);

    useEffect(() => {
        fetchBillType()
        fetchUsers()
    }, [])

    useEffect(() => {
        fetchData()
    }, [reload])

    useEffect(() => {
        const loadNextPage = () => {
            const isNearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            const hasMore = data.length < count;

            if (isNearBottom && hasMore && !loading && !loadingMore) {
                setLoadingMore(true);
                setFilter((current) => ({ ...current, skip: current.skip + 1 }));
                setReload((current) => current + 1);
            }
        };

        window.addEventListener('scroll', loadNextPage);
        loadNextPage();
        return () => window.removeEventListener('scroll', loadNextPage);
    }, [data, count, loading, loadingMore, filter.skip]);

    const fetchData = async () => {
        if (!loadingMore) setLoading(true);

        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.post(`${baseURL}/bill/get`, filter, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            const result = response.data?.data || {};
            const items = Array.isArray(result.items) ? result.items.filter(Boolean) : [];
            items.forEach((item) => {
                item.key = item.id;
            });
            setCount(Number(result.count) || 0);
            setData((current) => filter.skip === 0 ? items : [...current, ...items]);
            setLoading(false);
        } catch (error) {
            if (error.response?.status === 401) {
                navigate('/');
                return;
            }
            setData([]);
            setCount(0);
            toast.error(error.response?.data?.Msg || 'بارگذاری قبض‌ها با خطا مواجه شد');
            setLoading(false);
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    const refreshBills = () => {
        setData([]);
        setFilter((current) => ({ ...current, skip: 0 }));
        setLoading(true);
        setLoadingMore(false);
        setReload((current) => current + 1);
    };

    const fetchUsers = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

            var result = response.data.data;
            setDropDownUsers(result);
        } catch (error) {
        } finally {
        }
    };

    const fetchBillType = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/bill/getTypeDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

            var result = response.data.data;
            setDropDownBillTypes(result);
        } catch (error) {
        } finally {
        }
    };

    const deleteBill = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            await axios.delete(`${baseURL}/bill/delete?id=${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            refreshBills()
            setIsShowDeleteConfirmModalVisible(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const pay = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            await axios.get(`${baseURL}/bill/pay?id=${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            toast.success('با موفقیت انجام شد', {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setIsShowPayConfirmModalVisible(false)
            refreshBills()
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setIsShowPayConfirmModalVisible(false)
        }
    };

    const imageProps = {
        name: 'file',
        action: `${baseURL}/media/UploadFiles?containerkey=bills&isPublic=true`, // Replace with your upload endpoint
        headers: {
            authorization: 'Bearer ' + localStorage.getItem('damavandclub-token'),
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
            }
            if (info.file.status === 'done') {
                let mediaResponse = info.file.response.data[0];
                setBillPhoto(mediaResponse.url)
                setBillModel({ ...billModel, mediaId: mediaResponse.id })
                jquery(".ant-upload-list-text-container").remove();
            } else if (info.file.status === 'error') {
                return toast.warning(info.file.response.Msg, {
                    position: 'bottom-right',
                    autoClose: 3000, // milliseconds
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        },
    };

    const createBill = async () => {

        if (billModel.userIds == undefined || billModel.userIds == null || billModel.userIds.length == 0) {
            return toast.warning("هیچ عضوی انتخاب نشده است", {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
        }

        if (billModel.amount == undefined || billModel.amount == null || billModel.amount == 0 || billModel.amount == '') {
            return toast.warning("مبلغ وارد شده صحیح نیست", {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
        }

        setLoadingSave(true);
        const token = localStorage.getItem('damavandclub-token')

        try {
            await axios.post(`${baseURL}/bill/create`, billModel, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            refreshBills()
            setLoadingSave(false);
            setIsShowCreateBillModalVisible(false)
            setBillModel({ ...billModel, userId: null })
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setLoadingSave(false);
        } finally {
            setLoadingSave(false);
        }
    };

    const showCreateBillModal = async () => {
        //setBillModel({})
        setIsShowCreateBillModalVisible(true)
    };

    const setSelectedPayDeadLineDate = async (date) => {
        setPayDeadLineDate({
            year: date.year,
            month: date.month,
            day: date.day
        });
        setBillModel({ ...billModel, payDateDeadLine: `${date.year}/${date.month}/${date.day}` })
    }

    return (
        <div>
            <HideSidebarInMobileMode />
            {permissions.includes('createbill') ? <Button className="members-wallet-action members-wallet-create" onClick={() => showCreateBillModal()} style={{ marginTop: 10, width: '100%', marginBottom: 10 }}
                type="primary"><label>ایجاد قبض جدید</label></Button> : null}

            <Collapse className="bills-search-collapse" defaultActiveKey={['0']}>
                <Collapse.Panel header='جستجو ' key='1'>
                    <Select
                        style={{ width: '100%', marginTop: 10 }}
                        placeholder="انتخاب عضو"
                        allowClear={true}
                        showSearch
                        optionFilterProp="label"
                        onChange={(value) => {
                            setFilter({ ...filter, data: { ...filter.data, userId: value } })
                        }}
                    //value={WalletModel.userId}
                    >
                        {dropDownUser?.map((item) => (
                            <Option key={item.id} label={item.displayName} value={item.id}>
                                {item.displayName}
                            </Option>
                        ))}
                    </Select>

                    <Select
                        style={{ width: '100%', marginTop: 10 }}
                        placeholder="انتخاب نوع قبض"
                        allowClear={true}
                        onChange={(value) => {
                            setFilter({ ...filter, data: { ...filter.data, type: value } })
                        }}
                        value={billModel.type}
                    >
                        {dropDownBillType?.map((item) => (
                            <Option key={item.id} value={item.id}>
                                {item.displayName}
                            </Option>
                        ))}
                    </Select>

                    <div className='row'>
                        <div style={{ marginTop: 10 }} className='col-lg-6 col-sm-12'>
                            <div className='center-content customDatePickerWidth'>
                                <DatePicker
                                    value={fromCreateDate || null}
                                    //inputClassName='fullwidth'
                                    onChange={(value) => {
                                        setFromCreateDate(value)
                                        setFilter({ ...filter, skip: 0, limit: 10, data: { ...filter.data, fromCreateDate: `${value.year}/${value.month}/${value.day}` } })
                                    }}
                                    //minimumDate={persianToday}
                                    //calendarClassName="fullwidth"
                                    shouldHighlightWeekends
                                    locale='fa'
                                    inputPlaceholder='تاریخ صدور از'
                                />
                            </div>
                        </div>

                        <div style={{ marginTop: 10 }} className='col-lg-6 col-sm-12'>
                            <div className='center-content customDatePickerWidth'>
                                <DatePicker
                                    value={toCreateDate || null}
                                    //inputClassName='fullwidth'
                                    onChange={(value) => {
                                        setToCreateDate(value)
                                        setFilter({ ...filter, skip: 0, limit: 10, data: { ...filter.data, toCreateDate: `${value.year}/${value.month}/${value.day}` } })
                                    }}
                                    //minimumDate={persianToday}
                                    //calendarClassName="fullwidth"
                                    shouldHighlightWeekends
                                    locale='fa'
                                    inputPlaceholder='تاریخ صدور تا'
                                />
                            </div>
                        </div>
                    </div>


                    <Button className="bills-search-button" onClick={() => { setData([]); setLoading(true); setFilter({ ...filter, skip: 0, limit: 20 }); setReload((current) => current + 1); }}
                        loading={loading} style={{ backgroundColor: 'rgb(0 39 151)', marginTop: 10, width: '100%', marginBottom: 10 }}
                        type="primary"><label>جستجو</label></Button>
                    {/* <Button onClick={() => getExcel()} loading={loadingExcel} style={{ backgroundColor: 'rgb(229 131 27)', marginTop: 10, width: '100%', marginBottom: 10 }}
                        type="primary"><label>خروجی اکسل</label></Button> */}
                </Collapse.Panel>
            </Collapse>
            {loading && !loadingMore ? <div className="my-wallet-transactions-loading"><Spin size="large" /></div> : data.length > 0 ?
                <div className="my-wallet-transaction-grid my-bills-page-grid">
                    {data.map((record, index) => (
                        <article className={`my-wallet-transaction-card my-bill-card ${record.isPaid ? 'is-paid' : 'is-unpaid'}`} key={record.key || record.id || index}>
                            <div className="my-wallet-transaction-card-top">
                                <span className="members-wallet-member-name">{record.userFullName || 'عضو'}</span>
                                <span className={`my-bill-status ${record.isPaid ? 'is-paid' : 'is-unpaid'}`}>{record.isPaid ? 'پرداخت شده' : 'پرداخت‌نشده'}</span>
                            </div>
                            <div className="my-wallet-transaction-amount-row">
                                <div className="my-wallet-transaction-amount-label">مبلغ قبض</div>
                                <div className="my-wallet-transaction-amount"><AmountFormat amount={record.amount} /><span>ریال</span></div>
                            </div>
                            <div className="my-wallet-transaction-details">
                                {record.typeTitle ? <div><span>نوع قبض</span><strong>{record.typeTitle}</strong></div> : null}
                                {record.creatorName ? <div><span>ایجادکننده</span><strong>{record.creatorName}</strong></div> : null}
                                {record.persianPayDateDeadLine ? <div><span>مهلت پرداخت</span><strong>{record.persianPayDateDeadLine}</strong></div> : null}
                                {record.persianPayDate ? <div><span>تاریخ پرداخت</span><strong>{record.persianPayDate}</strong></div> : null}
                                {record.description ? <div><span>توضیحات</span><strong>{record.description}</strong></div> : null}
                            </div>
                            {record.photoUrl ? <a className="my-bill-photo-link" href={record.photoUrl} rel="noreferrer" target="_blank">
                                <img src={record.photoUrl} alt="تصویر قبض" /><span>مشاهده تصویر قبض</span>
                            </a> : <div className="my-bill-no-photo">تصویری برای این قبض ثبت نشده</div>}
                            {!record.isPaid ? <div className="my-bill-card-footer">
                                <Button type="primary" className="my-bill-pay-action" icon={<DollarOutlined />} onClick={() => {
                                    setIsShowPayConfirmModalVisible(true);
                                    setId(record.id);
                                }}>پرداخت از کیف پول</Button>
                                <Button className="my-bill-delete-action" icon={<DeleteOutlined />} aria-label="حذف قبض" onClick={() => {
                                    setIsShowDeleteConfirmModalVisible(true);
                                    setId(record.id);
                                }}>حذف</Button>
                            </div> : null}
                        </article>
                    ))}
                </div> : !loading ? <div className="my-wallet-transactions-empty">قبضی برای نمایش وجود ندارد</div> : null}
            {loadingMore && <div className="members-wallet-load-more"><Spin size="small" /></div>}
            <div className="members-wallet-total">
                <span>تعداد کل قبض‌ها</span>
                <strong>{count}</strong>
            </div>
            <Modal
                title='تایید حذف'
                open={isShowDeleteConfirmModalVisible}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container'>
                    <Button onClick={() => setIsShowDeleteConfirmModalVisible(false)} style={{ width: '100%' }}>بستن</Button>
                    <Button type="primary"
                        onClick={() => deleteBill()}
                        style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>تایید</Button>
                </div>
                }
                onCancel={() => setIsShowDeleteConfirmModalVisible(false)}
            >
            </Modal>
            <Modal
                title='تایید پرداخت از کیف پول'
                open={isShowPayConfirmModalVisible}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container'>
                    <Button onClick={() => setIsShowPayConfirmModalVisible(false)} style={{ width: '100%' }}>بستن</Button>
                    <Button type="primary"
                        onClick={() => pay()}
                        style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>تایید</Button>
                </div>
                }
                onCancel={() => setIsShowPayConfirmModalVisible(false)}
            >
            </Modal>
            <Modal
                className="create-bill-modal"
                title={`ایجاد قبض`}
                open={isShowCreateBillModalVisible}
                width={1000}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container create-bill-footer'>
                    <Button onClick={() => {
                        setBillModel(initialBillModel)
                        setPayDeadLineDate(null);
                        setIsShowCreateBillModalVisible(false)
                    }} style={{ width: '100%' }}>بستن</Button>
                    <Button className="create-bill-save" type="primary" loading={loadingSave}
                        onClick={() => createBill()}
                        style={{ width: '100%', marginRight: 10 }}>ذخیره</Button>
                </div>}
            >
                <div className="create-bill-content">
                    <div className="create-bill-fields">
                        <div className="create-bill-field create-bill-field-wide">
                            <label>مبلغ قبض (ریال)</label>
                            <InputNumberFormat value={billModel.amount} placeholder="مبلغ به ریال (اعداد انگلیسی)"
                                onValueChange={(value) => setBillModel({ ...billModel, amount: value })} />
                        </div>
                        <div className="create-bill-field">
                            <label>نوع قبض</label>
                            <Select
                                placeholder="انتخاب نوع قبض"
                                onChange={(value) => setBillModel({ ...billModel, type: value })}
                                value={billModel.type}
                            >
                                {dropDownBillType?.map((item) => (
                                    <Option key={item.id} value={item.id}>{item.displayName}</Option>
                                ))}
                            </Select>
                        </div>
                        <div className="create-bill-field">
                            <label>اعضای دریافت‌کننده</label>
                            <Select
                                placeholder="انتخاب یک یا چند عضو"
                                showSearch
                                mode="multiple"
                                optionFilterProp="label"
                                onChange={(value) => setBillModel({ ...billModel, userIds: value })}
                                value={billModel.userIds}
                            >
                                {dropDownUser?.map((item) => (
                                    <Option key={item.id} label={item.displayName} value={item.id}>{item.displayName}</Option>
                                ))}
                            </Select>
                        </div>
                        <div className="create-bill-field create-bill-field-wide">
                            <label>توضیحات</label>
                            <input
                                placeholder='توضیحات اختیاری قبض'
                                value={billModel.description}
                                onChange={(event) => setBillModel({ ...billModel, description: event.target.value })} />
                        </div>
                        <div className="create-bill-field">
                            <label>مهلت پرداخت</label>
                            <div className='center-content customDatePickerWidth'>
                                <DatePicker
                                    value={payDeadLineDate || null}
                                    onChange={(value) => setSelectedPayDeadLineDate(value)}
                                    shouldHighlightWeekends
                                    locale='fa'
                                    inputPlaceholder='انتخاب تاریخ'
                                />
                            </div>
                        </div>
                        <div className="create-bill-field create-bill-image-field">
                            <label>تصویر قبض (اختیاری)</label>
                            <Upload
                                {...imageProps}
                                //action={publicUploadPath()}
                                style={{ width: 200 }}
                //listType="picture-card"
                // itemRender={(originNode, file) => (
                //   <DraggableUploadListItem originNode={originNode} file={file} />
                // )}
                //fileList={fileList}
                //onPreview={handlePreview}
                //onChange={handleChange}
                >
                                <Button icon={<UploadOutlined />} type="primary"><label>آپلود تصویر</label></Button>
                    {/* <Button >Click to Upload</Button> */}
                    {/* {fileList.length >= 8 ? null : uploadButton} */}
                            </Upload>
                        </div>
                    </div>
                {billPhoto ? <img
                    className="create-bill-image-preview"
                    src={billPhoto}
                    alt="پیش‌نمایش تصویر قبض"
                /> : null}
                </div>
            </Modal>
        </div>
    )
}

export default BillList
